// src/features/articles/components/CodeBlock.jsx
import React, { useEffect, useRef, useState } from "react";
import Prism from "prismjs";
import "prismjs/themes/prism.css";
import "prismjs/components/prism-jsx.min";
import "prismjs/components/prism-bash.min";
import "prismjs/components/prism-json.min";
import "prismjs/components/prism-markup.min";
import { Toast, ToastContainer } from "react-bootstrap";

import { BsCopy, BsCheck } from "react-icons/bs";

export default function CodeBlock({ code, language = "javascript", filename }) {
  const ref = useRef(null);
  const [copied, setCopied] = useState(false);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (ref.current) Prism.highlightElement(ref.current);
  }, [code, language]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setShowToast(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  return (
    <div className="article-codeblock">
      
      {/* ---- Header Bar ---- */}
      <div className="codeblock-header">
        <div className="code-info">
          {filename && <span className="codeblock-filename">{filename}</span>}
          <span className="codeblock-language">{language}</span>
        </div>

        <button onClick={handleCopy} className="copy-btn">
          {copied ? (
            <>
              <BsCheck /> Copied
            </>
          ) : (
            <>
              <BsCopy /> Copy
            </>
          )}
        </button>
      </div>

      {/* ---- Code Section ---- */}
      <pre className={`language-${language}`}>
        <code ref={ref} className={`language-${language}`}>
          {code}
        </code>
      </pre>

      {/* ---- Toast ---- */}
      <ToastContainer position="bottom-end" className="p-3">
        <Toast 
          onClose={() => setShowToast(false)} 
          show={showToast} 
          delay={1600} 
          autohide 
          bg="light"
        >
          <Toast.Header closeButton>
            <strong className="me-auto">คัดลอกโค้ดแล้ว</strong>
            <small>พร้อมใช้งาน</small>
          </Toast.Header>
          <Toast.Body>โค้ดถูกคัดลอกไปยังคลิปบอร์ดเรียบร้อยแล้ว ✅</Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
}
